var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-code',{attrs:{"title":"Agregar el path de la compañía"}},[_c('b-card-body',[(_vm.accessPermissions('users.change.path'))?_c('FormCreateComponent'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }